module.exports = __webpack_public_path__ + "img/4f1cf2c46fba496d95233374e280bbaa-640.c7dcc10c.jpg";